import axios from 'axios';

const defaults = {
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  withXSRFToken: true,
  timeout: 10000,
};

const $apiPublic = axios.create(defaults);

$apiPublic.interceptors.request.use(
  config => config,
  error => {
    throw error;
  },
);

$apiPublic.interceptors.response.use(
  response => response.data,
  error => {
    throw error;
  },
);

export default $apiPublic;
